import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

// Actions
import { clearPincodeRankingByTg } from "../../../actions/regions/RegionActions";

// Constants and Utils
import { downloadPdf } from "../../../common-utils/file-utils/PdfUtil";
import { PincodeRankingId } from "../../../constants/GeneralConstants";

// Remove Selected Tg Button
function RemoveSelectedTgButton() {
  const dispatch = useDispatch();

  function handleRemove() {
    dispatch(clearPincodeRankingByTg());
  }

  return (
    <button
      className="btn add-button btn-outline-primary shadow-none mr-2"
      onClick={handleRemove}
    >
      Remove
    </button>
  );
}

// Download PDF Button
function DownloadPdfButton() {
  const cityName = useSelector((state) => state.saveMapState.cityName);

  async function handleDownload() {
    const fileName = `Area Ranking_${cityName}.pdf`;
    const input = document.getElementById(PincodeRankingId);

    try {
      await downloadPdf(input, fileName);
      toast.success("Successfully Downloaded");
    } catch (err) {
      toast.error("Download failed");
      console.error("Download failed:", err);
    }
  }

  return (
    <button
      className="btn add-button btn-outline-primary shadow-none"
      onClick={handleDownload}
    >
      Download
    </button>
  );
}

function RankedPincodeSection({ rankedBoundariesPolygonData = {} }) {
  const { features = [] } = rankedBoundariesPolygonData || {};

  return (
    <div className="p-2">
      <h5 className="font-weight-bold mb-1">Area Ranking</h5>
      <ul className="mb-0">
        {features?.map((eachFt, index) => {
          const { name, alias } = eachFt?.properties || {};
          return (
            <li key={index} className="p-1">
              <span>
                <strong>Rank {index + 1}</strong> : {name} : {alias}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

// SelectedTgAttrForRankingSection
export default function SelectedTgAttrForRankingSection({
  appliedTgAttrMapForRanking,
}) {
  // ranked pincode boundaries polygon data
  const rankedBoundariesPolygonData = useSelector(
    (state) => state.region.rankedBoundariesPolygonData
  );

  return (
    <div id={PincodeRankingId}>
      <div className="d-flex justify-content-between border-bottom p-2 pb-3">
        <h4 className="mt-1">Selected TG Attributes</h4>
        <div className="d-flex align-items-center">
          <RemoveSelectedTgButton />
          <DownloadPdfButton />
        </div>
      </div>

      <div className="p-3">
        {Object.keys(appliedTgAttrMapForRanking).map((attrGroup) => {
          const childrenLabels = appliedTgAttrMapForRanking[attrGroup];

          // hide group label if no children present
          if (childrenLabels.length === 0) {
            return null;
          }

          return (
            <div key={attrGroup} className="border-bottom pb-1 mb-2">
              <p className="mb-0 font-weight-bold">{attrGroup}</p>

              <ul className="row mb-0">
                {childrenLabels?.map((eachAttr) => {
                  return (
                    <li key={eachAttr} className="col-3 p-1">
                      <span>{eachAttr}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>

      {/* pincodes ranking */}
      <RankedPincodeSection
        rankedBoundariesPolygonData={rankedBoundariesPolygonData}
      />
    </div>
  );
}
